import React, { Component } from 'react';
import orderService, { OrderCommitAction } from '../OrderService';
import { StepPanel } from '../../controls/StepPanel';
import { EarmoldStep1Page } from './EarmoldStep1Page';
import { EarmoldStep2Page } from './EarmoldStep2Page';
import { EarmoldStep3Page } from './EarmoldStep3Page';
import { EarmoldStep4Page } from './EarmoldStep4Page';
import { EarmoldStep5Page } from './EarmoldStep5Page';
import { EarmoldStep6Page } from './EarmoldStep6Page';
import ScanFileDialog from './../ScanFileDialog';
import authService from '../../api-authorization/AuthorizeService'
import { AccountGroup } from '../../infrastructure/AppConstants';

export class EarmoldSheet extends Component {
    constructor(props) {
        super(props);
        EarmoldStep4Page.bteOrRic = "";
        this.handleBack = this.handleBack.bind(this);
        this.handleNext = this.handleNext.bind(this);
        this.handleFinish = this.handleFinish.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleOnlySave = this.handleOnlySave.bind(this);
        this.handleReview = this.handleReview.bind(this);
        this.stepHeaders = ["BaseInfo", "BTEORRIC", "EarmoldType", "EarmoldVersion", "EarmoldOptions", "SignAndDate"];
        this.stepSubTitles = ["BaseInfoTitle", "BTEORRICTitle", "EarmoldTypeTitle", "EarmoldVersionTitle", "EarmoldOptionsTitle", "SignAndDateTitle"];
        this.stepRefs = [React.createRef(), React.createRef(), React.createRef(), React.createRef(), React.createRef(), React.createRef()];
        this.stepContents = [this.renderStep1(), this.renderStep2(), this.renderStep3(), this.renderStep4(), this.renderStep5(), this.renderStep6()];
    }
    async componentDidMount() {
        await orderService.loadEarmoldOptionSettings();
    }
    handleBack(oldStep, newStep) {
    }

    async handleNext(oldStep, newStep) {
        //TODO submit or not ?
        await orderService.save(OrderCommitAction.Save);
    }

    async handleSave() {
        //TODO submit
        await orderService.save(OrderCommitAction.Save);
        window.history.back(-1);
    }
    async handleReview(isDigitalizedFileRequired) {
        const eardrumOrderType = (await orderService.getCurrentOrder()).eardrumCustomerInfo.eardrumOrderType;
        if (isDigitalizedFileRequired && eardrumOrderType != 3) {
            await orderService.save(OrderCommitAction.Save);
            this.scanFileDialog.open(OrderCommitAction.DealerReview);
            return;
        }
        await orderService.save(OrderCommitAction.DealerReview);
        window.history.back(-1);
    }

    async handleOnlySave() {
        await orderService.save(OrderCommitAction.Save);
    }

    async handleFinish() {
        //TODO submit
        const accountGroup = authService.getCurrentUser().accountGroup;
        const eardrumOrderType = (await orderService.getCurrentOrder()).eardrumCustomerInfo.eardrumOrderType;
        console.log(eardrumOrderType);
        if ((accountGroup == AccountGroup.DealerAdmin && this.props.model.attachmentFile) || eardrumOrderType == 3) {
            await orderService.save(OrderCommitAction.Submit);
            window.history.back(-1);
        } else {
            await orderService.save(OrderCommitAction.Save);
            this.scanFileDialog.open();
        }
        // window.history.back(-1);
    }
    closeScanFileDialog(e) {
        this.scanFileDialog.close();
    }
    incrementCounter() {
        this.setState({
            currentCount: this.state.currentCount + 1
        });
    }
    renderStep1() {
        return <EarmoldStep1Page ref={this.stepRefs[0]} model={this.props.model} />;
    }

    renderStep2() {
        return <EarmoldStep2Page ref={this.stepRefs[1]} model={this.props.model.eardrumInfo} />;
    }

    renderStep3() {
        return <EarmoldStep3Page ref={this.stepRefs[2]} model={this.props.model.eardrumInfo} leftRightOption={this.props.model.leftRightOption} />;
    }

    renderStep4() {
        return <EarmoldStep4Page ref={this.stepRefs[3]} model={this.props.model.eardrumInfo} leftRightOption={this.props.model.leftRightOption} />;
    }

    renderStep5() {
        return <EarmoldStep5Page ref={this.stepRefs[4]} model={this.props.model.eardrumInfo} leftRightOption={this.props.model.leftRightOption} />;
    }

    renderStep6() {
        return <EarmoldStep6Page ref={this.stepRefs[5]} model={this.props.model} />;
    }

    render() {
        return <div><StepPanel model={this.props.model} stepHeaders={this.stepHeaders}
            stepSubTitles={this.stepSubTitles}
            stepContents={this.stepContents}
            stepRefs={this.stepRefs}
            currentStep={0}
            onBack={this.handleBack}
            onNext={this.handleNext}
            onFinish={this.handleFinish}
            onSave={this.handleSave} onOnlySave={this.handleOnlySave} onReview={this.handleReview} />
            <ScanFileDialog onRef={(ref) => { this.scanFileDialog = ref }} leftRightOption={this.props.model.leftRightOption} id={this.props.id} onClose={this.closeScanFileDialog}></ScanFileDialog>
        </div>
    }
}